import { render, staticRenderFns } from "./regulDbUpload.vue?vue&type=template&id=6524b668"
import script from "./regulDbUpload.vue?vue&type=script&lang=js"
export * from "./regulDbUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6524b668')) {
      api.createRecord('6524b668', component.options)
    } else {
      api.reload('6524b668', component.options)
    }
    module.hot.accept("./regulDbUpload.vue?vue&type=template&id=6524b668", function () {
      api.rerender('6524b668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/db/regulDbUpload.vue"
export default component.exports